export const MODAL_HIDE = 'MODAL_HIDE';

export const MODAL_SHOW = 'MODAL_SHOW';
